import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import { Popover } from 'module/ui/components/atoms/popover';
import { Short01 } from 'module/ui/components/styles';
import styled from 'styled-components';
import { DocumentTitleInput } from 'components/organisms/document/title';

const Wrapper = styled(CenterAlignedBox)`
  ${Short01};
`;

const EditableTitle = styled.div`
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-04);
  color: var(--text-primary);
  width: fit-content;
`;

interface Props {
  value: string;
  onChange: (value: string) => void;
  readonly?: boolean;
}

export const TemplateTitle = ({ value, onChange, readonly }: Props) => {
  return (
    <Wrapper>
      {readonly ? (
        <EditableTitle>{value}</EditableTitle>
      ) : (
        <Popover
          trigger="click"
          placement="bottomLeft"
          content={<DocumentTitleInput value={value} onChange={onChange} />}
        >
          <EditableTitle>{value}</EditableTitle>
        </Popover>
      )}
    </Wrapper>
  );
};
